import {Component, OnInit} from '@angular/core';
import {AuthService, UserData} from "../../auth.service";
import {Router} from "@angular/router";
import {User} from "../../modules/task/interfaces/comments.interface";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  endDate?: Date | null
  startDate?: Date | null
  userData = JSON.parse(localStorage.getItem('userData')!) as UserData
  isExternal = this.userData.department === 'External User'
  isTransport = this.userData.department === 'Transport'
    isEducation = this.userData.department === 'Education'
  isCounselling = this.userData.department === 'Counselling'
  isDonor = this.userData.department === 'Finance And Accounts'
  isOperations = this.userData.department === 'Operations'

  constructor(
    private readonly authService: AuthService,
    private router: Router
  ) {
    // if(authService.getRole()=='Teacher'){
    //   this.router.navigateByUrl('education')
    // }
    // else if(authService.getRole()=='Psychologist'){
    //   this.router.navigateByUrl('/home/counseling')
    // }
    // else if(authService.getRole()=='Centre'){
    //     this.router.navigateByUrl('/home/childdetails')
    // }
  }

  ngOnInit(): void {

  }


}
